<template>
  <div>
    <!-- data table -->
    <v-data-table
      class="elevation-3 rounded-t-0"
      :items-per-page="page_count"
      :server-items-length="page_count"
      :loading="loading"
      loading-text="Please wait.... Loading"
      :headers="headers"
      :items="items"
      hide-default-footer
      mobile-breakpoint
    >
      <template v-slot:[`item.date`]="{ item }">
        {{ $utils.getDateFormat(item.datetime) }}
      </template>

      <template v-slot:[`item.case`]="{ item }">
        <div v-if="item.case">
          {{ item.case.case_id }}
        </div>
        <v-icon v-else>mdi-minus</v-icon>
      </template>

      <template v-slot:[`item.credit`]="{ item }">
        <div v-if="item.credit_amount" class="green--text font-weight-bold">
          +{{ item.credit_amount }}
        </div>
        <v-icon v-else>mdi-minus</v-icon>
      </template>

      <template v-slot:[`item.debit`]="{ item }">
        <div v-if="item.debit_amount" class="red--text font-weight-bold">
          -{{ item.debit_amount }}
        </div>
        <v-icon v-else>mdi-minus</v-icon>
      </template>

      <template v-slot:[`item.balance`]="{ item }">
        <div v-if="item.balance_amount" class="font-weight-bold">
          {{ item.balance_amount }}
        </div>
        <div v-else>0</div>
      </template>
    </v-data-table>

    <!-- pagination -->
    <v-container
      class="d-flex justify-space-between align-center px-0 mb-0 mt-4"
      fluid
    >
      <div class="d-flex align-center text-subtitle-2">
        <div class="mr-2">Rows per page</div>
        <div style="width: 75px">
          <v-select
            :menu-props="{ bottom: true, offsetY: true }"
            :items="itemsPerPageList"
            v-model="page_count"
            hide-details
            dense
            solo
            color="primary"
          ></v-select>
        </div>
        <div class="ml-6">
          Results: {{ pageStart }} - {{ pageEnd }} of {{ total_count }}
        </div>
      </div>
      <v-pagination
        v-model="page_number"
        :length="page_total"
        :total-visible="5"
        color="primary"
      >
      </v-pagination>
    </v-container>
  </div>
</template>

<script>
import { mapActions } from "vuex";

import { ledgerTable } from "@/headers";
export default {
  data() {
    return {
      items: [],
      loading: false,

      page_total: 1,
      page_number: 1,
      total_count: 0,
      page_count: 10,
      itemsPerPageList: [5, 10, 15, 20, 30, 40, 50],
    };
  },

  computed: {
    headers() {
      return ledgerTable;
    },

    pageStart() {
      let start = (this.page_number - 1) * this.page_count + 1;
      if (start + 1 > this.total_count) start = this.total_count;
      return start;
    },

    pageEnd() {
      let end = this.pageStart + this.page_count - 1;
      if (end > this.total_count) end = this.total_count;
      return end;
    },
  },

  watch: {
    page_count() {
      this.getLedgerList();
    },

    page_number() {
      this.getLedgerList();
    },
  },

  mounted() {
    this.getLedgerList();
  },

  methods: {
    ...mapActions({
      showSnackbar: "snackBar/showSnackbar",
    }),

    getLedgerList() {
      this.loading = true;
      this.items = [];

      const onSuccess = (res) => {
        this.items = res.data.data;

        const page_info = res.data.page_info;
        this.page_total = page_info.page_total;
        this.page_number = page_info.page_number;
        this.total_count = page_info.total_count;
      };

      const onFinally = () => {
        this.loading = false;
      };

      const params = {
        page_number: this.page_number,
        page_count: this.page_count,
      };

      return this.$request(this.$keys.GET, this.$urls.ledger.list, {
        params,
        onSuccess,
        onFinally,
        cancel: true,
      });
    },
  },
};
</script>